// extracted by mini-css-extract-plugin
export var checkbox = "_7c-0";
export var circle = "_7c-3";
export var horizontalContainer = "_7c-7";
export var sm = "_7c-5";
export var switch0 = "_7c-2";
export var switchDisabled = "_7c-8";
export var switchEnabled = "_7c-1";
export var textSwitchContainer = "_7c-9";
export var textSwitchOption = "_7c-a";
export var textSwitchOptionSelected = "_7c-b";
export var verticalContainer = "_7c-6";
export var xs = "_7c-4";